export default __webpack_public_path__ + "static/media/t1Comedor.6caf86a2.jpg";